import { type DefaultContext, mutationPromise } from '@egw/clients'
import {
  type EnrollmentHYCSGetStartedData,
  type EnrollmentHYCSGetStartedSubmitInput,
  type EnrollmentHYCSGetStartedSubmitOutput,
} from '../../../../models'
import { createMutationHook, createQueryHook } from '../../../../hooks'

/**
 * Get Enrollment GetStarted data
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<EnrollmentHYCSGetStartedData>
 * @example const response = await getEnrollmentHYCSGetStartedData()
 */
export const getEnrollmentHYCSGetStartedData = async (
  context?: DefaultContext,
): Promise<EnrollmentHYCSGetStartedData> => {
  const response = (await mutationPromise(
    {
      name: 'getEnrollmentHYCSGetStartedData',
      query: `mutation getEnrollmentHYCSGetStartedData($submitEnrollmentInput: SubmitEnrollmentInput!) {
        submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
          ... on SubmitEnrollmentSuccess {
            __typename
            path
          }
          ... on SubmitEnrollmentError {
            __typename
            path
          }
        }
      }`,
    },
    {
      submitEnrollmentInput: {},
    },
    context,
  )) as { submitEnrollment: EnrollmentHYCSGetStartedData }
  return response.submitEnrollment
}

export const useGetEnrollmentHYCSGetStartedData = createQueryHook<undefined, EnrollmentHYCSGetStartedData>(
  getEnrollmentHYCSGetStartedData,
)

/**
 * Submit Enrollment GetStarted data
 * @param context - reference to the AbortController used to abort the call (optional)
 * @returns Promise<EnrollmentHYCSGetStartedSubmitOutput>
 * @example const response = await submitEnrollmentHYCSGetStartedData();
 */
export const submitEnrollmentHYCSGetStartedData = async (
  enrollmentGetStartedSubmitInput: EnrollmentHYCSGetStartedSubmitInput,
  context?: DefaultContext,
): Promise<EnrollmentHYCSGetStartedSubmitOutput> => {
  const response = (await mutationPromise(
    {
      name: 'submitEnrollmentHYCSGetStartedData',
      query: `mutation submitEnrollmentHYCSGetStartedData($submitEnrollmentInput: SubmitEnrollmentInput!) {
        submitEnrollment(submitEnrollmentInput: $submitEnrollmentInput) {
          ... on SubmitEnrollmentSuccess {
            __typename
            path
          }
          ... on SubmitEnrollmentError {
            __typename
            path
            type
          }
        }
      }`,
    },
    {
      submitEnrollmentInput: enrollmentGetStartedSubmitInput,
    },
    context,
  )) as { submitEnrollment: EnrollmentHYCSGetStartedSubmitOutput }
  return response.submitEnrollment
}

export const useSubmitEnrollmentHYCSGetStartedData = createMutationHook<
  EnrollmentHYCSGetStartedSubmitInput,
  EnrollmentHYCSGetStartedSubmitOutput
>(submitEnrollmentHYCSGetStartedData)
